import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import { IoMdAnalytics, IoMdCamera, IoMdChatboxes, IoMdCheckmarkCircleOutline, IoMdClipboard, IoMdCodeWorking, IoMdCube, IoMdGitNetwork, IoMdLaptop, IoMdPie, IoMdSettings, IoMdSpeedometer } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingTop: "20px",
					paddingBottom: "50px"
				}}
			>
				<div 
					className="container"
					
				>
					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Services
							</h6>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="ICT CONSULTANCY"
								icon={IoMdAnalytics}
								content="Expert advice on technology planning, upgrades, and integration."
								navToLink={{
									item: 'services',
									subItem: 'ICT_consultancy'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title=" SOFTWARE DEVELOPMENT"
								content="Custom software and web apps built to fit your business needs."
								icon={IoMdCodeWorking}
								navToLink={{
									item: 'services',
									subItem: 'software_development'
								}}
							/>

						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="NETWORK & INFRASTRUCTURE SERVICES"
								content="Reliable network setup and system integration for smooth operations."
								icon={IoMdGitNetwork}
								navToLink={{
									item: 'services',
									subItem: 'network&infrastructure'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title=" HARDWARE SALES & SUPPORT SERVICES"
								content="Supply and maintenance of quality ICT hardware and accessories."
								icon={IoMdLaptop}
								navToLink={{
									item: 'services',
									subItem: 'hardware&support'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="MANAGED SERVICES"
								content="Complete IT management ensuring performance and reliability."
								icon={IoMdSettings}
								navToLink={{
									item: 'services',
									subItem: 'managed_services'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
								title="UNIFIED COMMUNICATION"
								content="Integrated email and messaging solutions for seamless collaboration."
								icon={IoMdChatboxes}
								navToLink={{
									item: 'services',
									subItem: 'unified_communication'
								}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
							title="PROJECT MANAGEMENT"
							content="Comprehensive management of projects to ensure timely and efficient delivery."
							icon={IoMdClipboard}
							navToLink={{
								item: 'services',
								subItem: 'project_management'
							}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
							title="ICT & CCTV CAMERAS"
							content="Installation and maintenance of ICT systems and CCTV security solutions."
							icon={IoMdCamera}
							navToLink={{
								item: 'services',
								subItem: 'ict_cctv'
							}}
							/>
						</div>

						<div className="col-md-6 mb-1 mt-1">
							<OneService
							title="INDUSTRIAL CHEMICALS IMPORTATION & DISTRIBUTION"
							content="Safe and compliant handling, storage, and distribution of industrial chemicals."
							icon={IoMdCube}
							navToLink={{
								item: 'services',
								subItem: 'industrial_chemicals'
							}}
							/>
						</div>


						
					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
